<template>
  <li class="soha-timeline-item mb-12">
    <slot />
  </li>
</template>

<script>
import "@/assets/css/components/base/timeline-item.css";
export default {
  name: "TimeLine",
};
</script>

<style scoped></style>
